import React from "react";
import style from "./projects.module.css"
import Project from "./project";
import naukri1 from "../images/naukri1.png";
import naukri2 from "../images/naukri2.png";
import naukri3 from "../images/naukri3.png";
import naukri4 from "../images/naukri4.png";
import naukri5 from "../images/naukri5.png";
import fraazo1 from "../images/fraazo1.png";
import fraazo2 from "../images/fraazo2.png";
import fraazo3 from "../images/fraazo3.png";
import fraazo4 from "../images/fraazo4.png";
import fraazo5 from "../images/fraazo5.png";
import fraazo6 from "../images/fraazo6.png";
import fraazo7 from "../images/fraazo7.png";
import fraazo8 from "../images/fraazo8.png";

const Projects = () => {
  let arrnauk = [naukri1, naukri2, naukri3, naukri4, naukri5];
  let arrfraazo = [fraazo1, fraazo2, fraazo3, fraazo4, fraazo5, fraazo6, fraazo7, fraazo8];
  const nauktxtarr = [
    "Naukri.com is an Indian employment website operating in India and Middle East.",
    "Users can Register, Login, Buy Premium Plan, Follow or Connect with Recruiters and also apply for recommended job roles",
    "Users can experience our website in their phone or tablets also",
    "TechStacks Used in this project are HTML, CSS, React JS, Javascript and Chakra UI",
    "Naukri Clone",
    "https://naukriclone98.vercel.app/",
    "https://github.com/KaustubhBadve/Naukri-Cloned"
  ];
  const frztxtarr = [
    "Fraazo is an e-commerce website which sells a variety of healthy food products.",
    "Users can Register, Login, Add to cart, Remove from cart, Check for product description, Check for Ordered items, Checkout for buying, Catch live location and Search for Product",
    "Users can experience our website in their phone or tablets also",
    "TechStacks Used in this project are CSS, React, Redux, Node.js, MongoDB, Express.js, Mongoose",
    "Fraazo Clone",
    "https://fraazo-website-clone.netlify.app/",
    "https://github.com/Prakarshprasar/cruel-statement-6939"
  ];
  return (
    <div className={style.center} id="projects">
      <h1>PROJECTS</h1>
      <Project arr={arrfraazo} txtarr={frztxtarr} />
      <Project arr={arrnauk} txtarr={nauktxtarr} />
      
    </div>
  );
};

export default Projects;
